import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "../../css/slider-animations.css";
import "../../css/homeslider.css";

const HomeSlider1 = ({ data, contentWrapperCls = "", btnCls = "" }) => {
  const navigate = useNavigate();
  const [autoplay, setAutoplay] = useState(false);

  // ⏳ Delay autoplay
  useEffect(() => {
    const timer = setTimeout(() => {
      setAutoplay(true);
    }, 1000); // 3 seconds (perfect UX)

    return () => clearTimeout(timer);
  }, []);

  return (
    <Slider
      autoplay={autoplay ? 1000 : false} // ⬅️ key line
      infinite
      className="slider-wrapper home-slider2"
    >
      {data.map((item, index) => (
        <div
          key={index}
          className="slider-content"
          onClick={() => item.link && navigate(item.link)}
          style={{
            background: `url('${item.image}') no-repeat center center`,
            cursor: item.link ? "pointer" : "default",
          }}
        >
          <div className={`inner ${contentWrapperCls}`}>
            {item.title && <h1>{item.title}</h1>}
            {item.description && <p>{item.description}</p>}
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default HomeSlider1;
